import { EventEmitter, Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class EnginesService {

    engineChanged: EventEmitter<void> = new EventEmitter();

    notifyEngineChange(): void {
        this.engineChanged.emit();
    }
}
